export class ValidatorHelper {

  static readonly nameValidator = /^[\p{L}\-\s']+$/u;
  static readonly emailValidator = /^\w([\w.-]*\w)?@\w([\w.-]*\w+)?$/;
  static readonly addressValidator = /^[\p{L}\-\s\d#,./']+$/u;
  static readonly cityValidator = /^[\p{L}\-\s#,.']+$/u;
  static readonly zipValidator = /^[\dA-z\s-]+$/;
  static readonly taxNumberValidator = /^[\dA-z-./\s]+$/;
  static readonly vatNumberValidator = /^[\dA-z-\s]+$/;
  static readonly companyValidator = /^[\p{L}\d&.'+/\s-]+$/u;
  static readonly urlValidator = /^(https?:\/\/)?[\p{L}\w]([\p{L}\w-]*[\p{L}\w])?(\.[\p{L}\w]([\p{L}\w-]*[\p{L}\w])?)*(\/[\p{L}\w]([\p{L}\w-]*[\p{L}\w])?)*([/\?#][/\p{L}\w,'"%-]*)*$/u;
  static readonly planerNumberValidator = /^[A-z\d]{5}$/;
  static readonly positionValidator = /^[\p{L}\-\s.']+$/u;
}
